$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = LANG.aguarde;

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		$('.loading-container').fadeOut(500, function () {
			$(this).remove();
		});
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	$('.open-popup,.toggle-popup').on('click', function () {
		if ($('.popup').hasClass('show')) {
			blockScroll(0);
			$('.popup').removeClass('show');
			$('#menu').removeClass('hide');
		}
		else {
			$('.popup').addClass('show');
			$('#menu').addClass('hide');
			blockScroll(1);
		}

	});

	/**
	 * Fade loading images
	 */
	/*var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}*/

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 50);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	/**
	 * Exemplo de submissão de form
	 */
	$('body').on('click', '#send-suggestion', function (e) {
		e.preventDefault();

		var form = $('form.suggestion-form');
		var fields = form.serialize();
		var action = form.attr('action');

		if (checkPolicy(form)) {
			var send = true;
			form.find('#feedback__suggestion').removeClass().html('');
			form.find('.invalid').removeClass('invalid');

			if ($('#email').length) {
				var email = $('#email').val();
				if (!IsEmail(email)) {
					form.find('#email').parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.email_invalido).addClass('error').fadeIn("fast");
					send = false;
				}
			}

			var required = form.find('.required');
			required.each(function () {
				if ($.trim($(this).val()) == '' || $.trim($(this).val()) == $(this)[0].defaultValue) {
					$(this).parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.preencha_os_campos_em_falta).addClass('error').fadeIn("fast");
					send = false;
				}
			});
			if (send) {
				$.blockUI();
				$.ajax({
					url: action,
					type: 'POST',
					data: fields,
					dataType: 'json',
					success: function (r) {
						if (r.class == 'ok') {
							form[0].reset();
						}
						$('#feedback__suggestion').show().addClass(r.class).html(r.message);
						$.unblockUI();
					},
					error: function (r) {
						$('#feedback__suggestion').show().addClass('error').html(LANG.email_erro);
						$.unblockUI();
					}
				});
			}
		} else {
			$('#feedback__suggestion').show().addClass('error').html(LANG.accept_privacy_policy);
			$.unblockUI();
		}
	});

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	$('.homepage-slider').slick({
		arrows: false,
		fade: true,
		dots: true,
		draggable: false,
		autoplay: true,
		autoplaySpeed: 8000,
		infinite: true,
		pauseOnHover: true,
		pauseOnDotsHover: true,
		prevArrow: false,
		nextArrow: false,
		responsive: [
		]
	});
	if ($('.produtos-slider .produto-item').length) {

		$('.produtos-slider').slick({
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			fade: false,
			dots: true,
			draggable: true,
			autoplay: false,
			infinite: false,
			responsive: [
				{
					breakpoint: 450,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 737,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				},
				{
					breakpoint: 1600,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}
				},
				{
					breakpoint: 2561,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
					}
				},
			]
		});

		// When the filter values are changed, 
		// apply the filter to slick.
		$('form.filter select').on('change', function () {

			var filterClass = getFilterValue();
			$('.filter-class').text(filterClass);
			$('.produtos-slider').slick('slickUnfilter');
			$('.produtos-slider').slick('slickFilter', filterClass);
		});


		/**
		 * This just reads the inputs from the 
		 * selects and creates the filter.
		 */
		function getFilterValue() {
			// Grab all the values from the filters.
			var values = $('.filter-group').map(function () {
				// For each group, get the select values.
				var groupVal = $(this).find('select').map(function () {
					return $(this).val();
				}).get();
				// join the values together.
				return groupVal.join('');
			}).get();


			// Remove empty strings from the filter array.
			// and join together with a comma. this way you 
			// can use multiple filters.
			return values.filter(function (n) {
				return n !== "";
			}).join(',');
		}
	}

	$('.produto-single-slider').slick({
		dots: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: false,
		touchThreshold: 20,
		infinite: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					// dots: false,
				}
			},
			{
				breakpoint: 737,
				settings: {
					// dots: false,
					// centerPadding: '80px',
				}
			},
			{
				breakpoint: 321,
				settings: {
					// dots: false,
					// centerPadding: '60px',
					// slidesToShow: 1.4,
				}
			},
		]
	});
	if ($('.mh').length) {
		$('.mh').matchHeight(true);
	}
	if ($('.mh1').length) {
		$('.mh1').matchHeight(true);
	}

	$('.btn-toggle-filtros').on('click', function () {
		if ($('.filters-container').hasClass('show')) {
			$('.filters-container').removeClass('show');
			blockScroll(0);
			$(this).removeClass('open');
		}
		else {
			$('.filters-container').addClass('show');
			blockScroll(1);
			$(this).addClass('open');
		}
	});
	/**
 * Scroll do menu
 */
	windowOnScroll();
	$(window).on('scroll', function () {
		// compensateRellax();
		windowOnScroll();
		// fixReleaseTabs();
	});

	$("#ordenar").change(function (e) {
		if (parseInt($(this).val()) == 0) {
			window.location.href = $(this).data("url");
		} else if ($(this).data("url").indexOf("?") != -1) {
			window.location.href = $(this).data("url").split('#')[0] + "&order=" + $(this).val() + "#lista-produtos";
		} else
			window.location.href = $(this).data("url") + "?order=" + $(this).val();
		});

	$('.tab-btn').on('click', function (e) {
		$(this).parent('.containers').toggleClass('close');
	});
	$('.filter-checkbox').on('change', function (e) {
		$('#filters-container').submit();
	});
	$('#filters-container').on('submit', function (e) {
		e.preventDefault();

		var query = $(this).serializeArray().filter(function (i) {
			if (i.value == 'null' || i.name == 'ci_token') {
				return null;
			} else {
				return i.value;
			}
		});

		var orderby = $('#orderby').length ? $('#orderby').find('option:selected').val() : '';
		if (orderby != '') {
			if (query.length > 0) {
				window.location.href = $('#loja-url').val() + (query ? ('?filtro=1&' + $.param(query) + '&' + orderby) : '');
			} else {
				window.location.href = $('#loja-url').val() + '?' + orderby;
			}
		} else {
			if (query.length > 0) {
				window.location.href = $(this).attr('action') + (query ? ('?filtro=1&' + $.param(query) + '#lista-produtos') : '');
			} else {
				window.location.href = $(this).attr('action') + '#lista-produtos';
			}
		}

	});

	/**
 * Abrir e fechar o menu
 */
	$('#menu-toggler').on('click', function () {
		toggleMenu();
	});
	function toggleMenu() {
		var el = $('#menu-toggler');
		if (el.hasClass('close')) {
			el.removeClass('close');
			$('.menu-container').removeClass('show');
			$('body').removeClass('menu-open');
			blockScroll(0);
		} else {
			el.addClass('close');
			$('body').addClass('menu-open');
			$('.menu-container').addClass('show');
			blockScroll(1);
		}
	}

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
	if ($(window).scrollTop() > 45 && $('body').hasClass('big') && $('body').hasClass('should-big')) {
		$('.should-big').removeClass('big');
	} else if ($(window).scrollTop() <= 45 && !$('body').hasClass('big') && $('body').hasClass('should-big')) {
		$('.should-big').addClass('big');
	}
	if ($(window).scrollTop() > 45 && !$('body').hasClass('scrolled')) {
		$('body').addClass('scrolled');
	} else if ($(window).scrollTop() <= 45 && $('body').hasClass('scrolled')) {
		$('body').removeClass('scrolled');
	}
}